/**
 * 관리자 ⑤ 코호트 리텐션
 * ($j.Pages.Admin.Cohort / body data-page-name="Cohort")
 *
 * 가입(첫 유료)월별 유지율 삼각형 + 첫 수주 경험 효과.
 */
export default class Cohort {
    constructor() {
        this.PAY = { cms: 'CMS', cash: '캐시', prepay: '선결제', nofee: '감면', exempt: '면제' };
    }

    initialize() {
        $('#chRefresh').on('click', () => this._load(true));
        $('#chTri').on('click', '.ch-clk', (e) => {
            const $c = $(e.currentTarget);
            this._openMembers($c.data('cohort'), $c.data('offset'));
        });
        this._load();
    }

    async _openMembers(cohort, offset) {
        try {
            const res = await $.ajax({ url: '/adm/ajax/stat/cohort/members', type: 'get', data: { cohort, offset } });
            if (!res.ok) return;
            const data = res.data || {};
            const retained = data.retained || [];
            const churned = data.churned || [];
            const off = Number(offset);

            const tbl = (rows, kind) => {
                const body = rows.map((m, i) => `<tr>
                    <td>${i + 1}</td>
                    <td>${$j.F.Admin.Member.Pop.cell(m.mb_no, m.mem_name)}</td>
                    <td>${m.pay_source ? `<span class="badge badge-secondary">${this.PAY[m.pay_source] || m.pay_source}</span>` : '-'}</td>
                    <td class="text-right">${this._c(m.baljoo)}</td>
                    <td class="text-right">${this._c(m.soojoo)}</td>
                    <td class="text-right">${m.baljoo_avg}</td>
                    <td class="text-right">${m.soojoo_avg}</td>
                </tr>`).join('');
                return `<table class="table table-sm table-bordered">
                    <thead><tr><th>#</th><th>이름</th><th>회비</th><th>발주</th><th>수주</th><th>발주<br><small>월평균</small></th><th>수주<br><small>월평균</small></th></tr></thead>
                    <tbody>${body || `<tr><td colspan="7" class="text-center text-muted">없음</td></tr>`}</tbody>
                </table>`;
            };

            // vh 는 --adm-zoom 으로 나눈다 (admin/base/_fontsize.scss) — 폴백 1 이라 보통은 그대로
            let html = `<div style="padding:4px 2px;max-height:calc(62vh / var(--adm-zoom, 1));overflow:auto;">`;
            html += `<div class="font-weight-bold text-success mb-1">유지 ${this._c(retained.length)}명</div>${tbl(retained)}`;
            if (off > 0) {
                html += `<div class="font-weight-bold text-danger mt-3 mb-1">이탈(유료였다가 빠짐) ${this._c(churned.length)}명</div>${tbl(churned)}`;
            }
            html += `</div>`;

            const target = this._addMonths(String(cohort), off);
            const title = `${this._fmt(cohort)} 가입자 · ${off === 0 ? '가입시점' : '+' + off + '개월'} (${this._fmt(target)} 기준)`;
            $j.Ui.JBModal.html('cohort-members-modal', html, title, { width: '480px' });
        } catch (e) {
            console.error('코호트 회원명단 로드 실패', e);
        }
    }

    async _load(nocache = false) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/cohort/data', type: 'get',
                data: nocache ? { nocache: 1 } : {}
            });
            if (!res.ok) return;
            this._renderFirstWin(res.first_win);
            this._renderTriangle(res.triangle, res.max_offset);
            if (res.cached_at) $('#chCachedAt').text(`집계시각 ${res.cached_at}`);
        } catch (e) {
            console.error('코호트 리텐션 로드 실패', e);
        }
    }

    _renderFirstWin(fw) {
        if (!fw) return;
        const won = fw.won || { size: 0, retained: 0, pct: 0 };
        const not = fw.not_won || { size: 0, retained: 0, pct: 0 };
        $('#chFwDesc').text(`${fw.cohort_from}~${fw.cohort_to} 가입자, ${fw.offset}개월 후에도 유료 유지 비율`);
        $('#chWonPct').text(won.pct + '%');
        $('#chWonSub').text(`${this._c(won.retained)} / ${this._c(won.size)}명 유지`);
        $('#chNotPct').text(not.pct + '%');
        $('#chNotSub').text(`${this._c(not.retained)} / ${this._c(not.size)}명 유지`);
        const gap = Math.round((won.pct - not.pct) * 10) / 10;
        $('#chGap').text((gap >= 0 ? '+' : '') + gap + '%p');
    }

    _renderTriangle(triangle, maxOffset) {
        const cols = [];
        for (let k = 0; k <= maxOffset; k++) cols.push(k);

        let html = '<thead><tr><th>가입월</th><th>가입수</th>'
            + cols.map(k => `<th>+${k}</th>`).join('') + '</tr></thead><tbody>';

        // 최신 코호트가 위로
        triangle.slice().reverse().forEach(c => {
            const map = {};
            c.retention.forEach(r => { map[r.offset] = r; });
            html += `<tr><td class="coh">${this._fmt(c.cohort)}</td><td>${this._c(c.size)}</td>`;
            cols.forEach(k => {
                const r = map[k];
                if (!r) { html += '<td></td>'; return; }
                const clickable = r.count > 0
                    ? ` class="ch-clk" data-cohort="${c.cohort}" data-offset="${k}" style="background:${this._color(r.pct)};cursor:pointer"`
                    : ` style="background:${this._color(r.pct)}"`;
                html += `<td${clickable}>
                    <div class="pct">${r.pct}%</div><div class="n">${this._c(r.count)}</div></td>`;
            });
            html += '</tr>';
        });
        html += '</tbody>';
        $('#chTri').html(html);
    }

    _color(pct) {
        // 100=초록, 50=노랑, 0=빨강
        const p = Math.max(0, Math.min(100, pct)) / 100;
        const hue = p * 120; // 0(red)~120(green)
        return `hsl(${hue}, 70%, 85%)`;
    }

    _fmt(mc) {
        const s = String(mc);
        return s.length === 6 ? `${s.slice(0, 4)}.${s.slice(4)}` : s;
    }

    /** YYYYMM 에 n개월 더한 YYYYMM */
    _addMonths(ym, n) {
        const y = parseInt(ym.slice(0, 4), 10), m = parseInt(ym.slice(4, 6), 10);
        const d = new Date(y, m - 1 + n, 1);
        return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {
        $j.Ui.JBModal.close();
    }
}
